import React from 'react';
import merge from 'lodash.merge';
import parse, { domToReact } from 'html-react-parser';
import { Link } from 'react-onei'

import * as resetTpl from '../conf/wording.conf';
import * as createTpl from '../conf/wording.create.conf';
import * as multibalTpl from "../conf/wording.multibal.conf";
import * as euijaTpl from "../conf/wording.euija.conf";

class WordingService {
  constructor() {
    this.template = {
      reset: resetTpl,
      create: createTpl,
      multibal: multibalTpl,
      euija: euijaTpl,
    }
    this.setDictionary('reset');
  }

  /**
   * Change global wording dictionary.
   * @param {string} dictionary | String dictionary configuration
   */
  setDictionary(dictionary) {
    if (this.template[dictionary] !== this.template.reset) {
      this.dictionary = merge({}, this.template.reset, this.template[dictionary]);
    } else {
      this.dictionary = merge({}, this.template[dictionary]);
    }
  }

  /**
   * Return the correct wording dictionary.
   * @param type
   * @param wording
   * @param props Object props passed to Link
   * @return {*}
   */
  getWording(type, wording, props = {}) {
    return parse(this.dictionary[type][wording], {
      replace: (domNode) => {
        if (domNode.name === 'a') {
          return (
            <Link {...domNode.attribs} {...props}>
              {domToReact(domNode.children)}
            </Link>
          );
        }
      }
    });
  }
}

export default new WordingService();
